// extracted by mini-css-extract-plugin
export default {"video-link":"n_bx d-flex align-items-center my-2","video-link__link":"n_by ml-2"};